import { ErrData, ErrDataPromise, MapLike } from '@iotv/iotv-v3-types'
import fs from 'fs'
import path from 'path'
const debugOverride = process.env.DEBUG_OVERRIDE === 'true'
const debug = (!process.env.AWS_SESSION_TOKEN && false) || debugOverride

type ValidationResponse = { err: Error | null; data: boolean | null }

export const hasFile = (path: string, fileName: string): Promise<ValidationResponse> =>
  new Promise((resolve, reject) => {
    let res: ValidationResponse = { err: null, data: null }
    fs.stat(`${path}/${fileName}`, (err, stats) => {
      if (err) {
        res.err = new Error(err.message)
      } else if (stats.isFile()) {
        res.data = true
      }
      resolve(res)
    })
  })

export const dirExist = (path: string): Promise<ValidationResponse> =>
  new Promise((resolve, reject) => {
    let res: ValidationResponse = { err: null, data: null }
    fs.stat(path, (err, stats) => {
      if (err) {
        res.err = new Error(err.message)
      } else if (stats.isDirectory()) {
        res.data = true
      }
      resolve(res)
    })
  })

export const createDir = (path: string): Promise<ValidationResponse> =>
  new Promise((resolve, reject) => {
    let res: ValidationResponse = { err: null, data: null }
    fs.mkdir(path, (err) => {
      if (err) {
        res.err = new Error(err.message)
      } else {
        res.data = true
      }
      resolve(res)
    })
  })

export const outputToPath = async (dirPath: string, fileName: string, output: MapLike<any> | any[]) => {
  let res: ValidationResponse = { err: null, data: null }
  const isDir = await dirExist(dirPath)
  let exists = false
  if (!isDir.data) {
    const createRes = await createDir(dirPath)
    if (createRes.data) {
      exists = true
      console.log(`Created directory: ${dirPath}`)
    } else {
      res = createRes
    }
  } else {
    exists = true
  }
  if (exists) {
    const filePath = path.join(dirPath, fileName)
    const fileExists = await hasFile(dirPath, fileName)
    if (fileExists.data) {
      debug && console.log(`overwriting ${filePath}`)
    } else {
      debug && console.log('Err in outputToPath', fileExists)
    }
    let outputStr: string | undefined = undefined
    try {
      outputStr = JSON.stringify(output, null, 1)
    } catch (e: any) {
      res.err = new Error(`Stringify threw error,: ${e.message}`)
    }
    if (typeof outputStr === 'string') {
      res = await new Promise((resolve, reject) =>
        fs.writeFile(filePath, outputStr as string, { encoding: 'utf-8' }, (err) => resolve({ err, data: !err ? true : null })),
      )
    }
  }
  return res
}

export const readObjectFromPath = async (dirPath: string, fileName: string): ErrDataPromise<MapLike<any> | any[]> => {
  let res: ErrData<MapLike<any> | any[]> = { err: null, data: null }
  const existsRes = await hasFile(dirPath, fileName)

  if (existsRes.data === true) {
    const obStrRes: ErrData<string> = await new Promise((resolve, reject) =>
      fs.readFile(path.join(dirPath, fileName), { encoding: 'utf-8' }, (err, data) => resolve({ err, data })),
    )
    try {
      if (obStrRes.data) {
        res.data = JSON.parse(obStrRes.data)
      }
    } catch (e: any) {
      if (e instanceof Error) {
        res.err = e
      }
    }
  } else {
    res.err = existsRes.err
  }

  return res
}

export const readStringFromPath = async (dirPath: string, fileName: string): ErrDataPromise<string> => {
  let res: ErrData<string> = { err: null, data: null }
  const existsRes = await hasFile(dirPath, fileName)
  debug && console.log(`${dirPath}.${fileName} exists ${existsRes.data} `)
  if (existsRes.data === true) {
    res = await new Promise((resolve, reject) => fs.readFile(path.join(dirPath, fileName), { encoding: 'utf-8' }, (err, data) => resolve({ err, data })))
  } else {
    res.err = existsRes.err
  }

  return res
}

export type PopulateVariableFromPathRequest = {
  variable: MapLike<any>
  dirPath: string
  fileName: string
}

export const populateVariableFromPath = async ({ variable, dirPath, fileName }: PopulateVariableFromPathRequest) => {
  const readRes = await readObjectFromPath(dirPath, fileName)
  if (readRes.data) {
    if (typeof readRes.data === 'object' && !(readRes.data instanceof Array)) {
      for (let [k, v] of Object.entries(readRes.data)) {
        variable[k] = v
      }
    }
  } else {
    console.log(`Swallowing Err ${readRes.err?.message}`)
  }
}
